<template>
  <el-form ref="form" label-position="left">
    <el-row type="flex">
      <el-col v-for="(item, index) in value" :key="item.key" :span="3.2">
        <el-form-item
          :label="index === 0 ? '度数范围:' : ''"
          :label-width="index === 0 ? '80px' : '10px'"
        >
          <el-input
            style="width: 60px"
            :value="item.start"
            @input="input(index, $event, 'start')"
          ></el-input
          ><span style="font-size:12px">至</span>
          <el-input
            style="width: 60px"
            :value="item.end"
            @input="input(index, $event, 'end')"
          ></el-input>
          <i
            class="el-icon-close del-icon"
            @click="delDegrees(index)"
            v-if="value.length > 1"
          ></i>
        </el-form-item>
      </el-col>
      <el-col :span="1.2" style="padding: 5px">
        <i class="el-icon-plus add-icon" @click="addDegrees"></i>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    value: {
      type: Array
    }
  },
  methods: {
    addDegrees() {
      this.value.push({
        start: '',
        end: '',
        key: Date.now()
      });
      this.$emit('input', this.value);
      //console.log(this.value, 'this.formData.degrees...');
    },
    delDegrees(index) {
      this.value.splice(index, 1);
      this.$emit('input', this.value);
    },
    input(i, value, type) {
      const v = [...this.value];
      v[i][type] = value;
      this.$emit('input', v);
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-form-item {
  font-size: 12px;

  .el-form-item__label {
    font-size: 12px;
    color: #fff;
  }

  .el-input__inner {
    border: none;
    border-bottom: 1px solid #fff;
    border-radius: 0;
  }
  .el-form-item__content {
    margin-left: 10px;
  }
  .add-icon,
  .del-icon {
    color: red;
    padding: 5px;
    box-sizing: border-box;
  }
  .add-icon {
    color: orange;
  }
  // /deep/.add-icon-col {
  //   padding-top: 5px;
  // }
}
</style>
